import { render, staticRenderFns } from "./VideoProductDetail.vue?vue&type=template&id=16243d26&scoped=true&"
import script from "./VideoProductDetail.vue?vue&type=script&lang=js&"
export * from "./VideoProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./VideoProductDetail.vue?vue&type=style&index=0&id=16243d26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16243d26",
  null
  
)

export default component.exports